export default __webpack_public_path__ + "static/media/book_image.bc28a54b.png";